
import { motion } from "framer-motion"
import styled from "@emotion/styled"

const SizeContainer = styled.div`
  display: flex;
  flex-wrap: nowrap;
  gap: 1rem;
  margin: 1rem 0;
`

const SizeButton = styled(motion.button)`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 2px solid ${(props) => (props.$isActive ? "#008000" : "#ffffff")};
  background: ${(props) => (props.$isActive ? "#008000" : "transparent")};
  color: ${(props) => (props.$isActive ? "#ffffff" : "#ffffff")};
  cursor: pointer;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.3s ease;

  &:hover {
    background: ${(props) => (props.$isActive ? "#008000" : "rgba(255, 255, 255, 0.1)")};
  }

  @media (max-width: 480px) {
    width: 32px;
    height: 32px;
    font-size: 0.9rem;
  }
`

export function SizeSelector({ sizes, activeSize, onSizeSelect }) {
  console.log(sizes)
  return (
    <SizeContainer>
      {sizes.map((size, index) => (
        <SizeButton
          key={index}
          $isActive={activeSize === size.description}
          onClick={() => onSizeSelect(size.description)}
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
        >
          {size.height}
        </SizeButton>
      ))}
    </SizeContainer>
  )
}

